<p>getproductandcost works!</p>
